export default {
    task: {
        getMyCash: 'என் ரொக்கத்தைக் கொடு',
        chances: 'வாய்ப்புகள் மீதமுள்ளன',
        tips: 'கார்டுகளைப் பெறுவதற்கான உதவிக்குறிப்பு',
        daily: 'தினசரி செக்-இன்',
        watch: 'ஏதேனும் வீடியோவைப் பாருங்கள்',
        share: 'போட்டியைப் பகிரவும்',
        free: 'இலவச ரொக்கம் மற்றும் கார்டு +1',
        done: 'முடிந்தது',
        go: 'செல்',
        success: 'வெற்றிகரமாக',
        checkIn: 'சரிபார்க்கப்பட்டது',
        successCheckIn: 'வெற்றிகரமாக செக் இன் செய்துள்ளீர்கள்!',
        successWatched: 'வெற்றிகரமாக பார்த்துள்ளீர்கள்!',
        successShared: 'வெற்றிகரமாக பகிர்ந்துள்ளீர்கள்!',
        won: 'நீங்கள் வென்றுள்ளீர்கள்',
        card: 'கார்டு',
        msg: 'உங்கள் கணக்கில் பணம் சேமிக்கப்பட்டது',
        ok: 'சரி',

        nochance: 'நீங்கள் அனைத்தையும் முடிக்கவில்லை',
        cards: '4-கார்ட்ஸ் ',
        collection:'சேகரிப்பு',
        watchVideo:'வீடியோ பாருங்கள் ',
        toGet:'மேலும் கார்டுகளை பெற'
    },
    
    rules: {
        ruleTitle: "விதிகள்",
        validityDate: "செல்லுபடி தேதி: மார்ச் 8,2020 - மார்ச் 15,2020",
        prizeRedeem: "பரிசை பணமாக்குதல்: பயனர்களின் இருப்புத் தொகை 15 ரூ ஆனவுடன் அவர்களின் ரொக்கத்தை எடுத்துக் கொள்ளலாம், பரிவர்த்தனை 7 வேலைநாட்களுக்குள் பூர்த்தியாகும்",
        gameRule:{
            title:"விளையாட்டு விதிகள்:",
            ruleList: [
                "1. பயனர்கள் தினசிர செக்-இன் செய்யும் போது ரொக்கம் மற்றும் 1 கார்டைப் பெறமுடியும்",
                "2. பயனர்கள் ஒரு நாளைக்கு ஏதேனும் வீடியோவைப் பார்த்து முடிக்கும் போது ரொக்கம் மற்றும் 1 கார்டைப் பெறமுடியும்",
                "3. பயனர்கள் செயலை வாட்ஸ்அப் குழு அல்லது ஃபேஸ்புக் அல்லது இன்ஸ்டாகிராம் மற்றும் இன்ன பிறவற்றில் பகிர்ந்து முடிக்கும் போது அவர்கள் ரொக்கம் மற்றும் 1 கார்டைப் பெறமுடியும்",
                "4. எல்லா 4 கார்டுகளையும் சேகரித்தவுடன், ஒரு லாட்டரி விளையாடுவதற்கான வாய்ப்பு பயனர்களுக்குக் கிடைக்கும். ஒவ்வொரு அதிர்ஷ்டக் குலுக்கலிலும், 30 லட்சம் ரொக்கத்திலிருந்து 100% வெற்றி பெற வாய்ப்புள்ளது, ஒவ்வொரு பயனரும் அதிகபட்சம் 20000 ரூ வெல்ல முடியும்"
            ]
        },
        msg:"இறுதி விளக்கத்துக்கான எல்லா உரிமையும் SHAREit -இடம் உள்ளது"
    },
    share: {
        title:"*விளையாட்டில்லை நண்பா, இந்த ஹோலியில் SHAREit உண்மையாகவே 30 லட்சம் ரொக்கப் பரிசு அளிக்கிறது!*😊\n*ரூ 20000 வரை பெறுவதற்கு என்னுடனே சேர்ந்து வீடியோக்களைப் பாருங்கள், ஒவ்வொரு 100% வெல்கிறார்கள்.*💰\n*நான் ஏற்கனவே இலவசமாக ரொக்கத்தைப் பெற்றுள்ளேன், இது 100% உண்மை.*\n*இந்த SHAREit ஹோலி போட்டியில் சேரலாம்!*💕👇🏻👇🏻👇🏻"
    }
}